import { gql, TypedDocumentNode } from "@apollo/client";

import { OriginIntegration } from "types/generated";

type GetOriginIntegrationData = {
  originIntegration: Pick<OriginIntegration, "vcsChecks" | "useGitCheckout" | "vcsCheckOptions">;
};
export const GET_ORIGIN_INTEGRATION: TypedDocumentNode<GetOriginIntegrationData> = gql`
  query GetOriginIntegration {
    originIntegration {
      vcsChecks
      useGitCheckout
      vcsCheckOptions {
        individualFailuresOnly
        individualSkipUnchanged
      }
    }
  }
`;
